import { Banner } from '#client/components/ui/Banner';
import type { PatientMatch } from './usePatientLookup';

/** Tells the desk this number is someone already on file, and what that means. */
export function ReturningPatientNotice({ match }: { match: PatientMatch }) {
  const visits =
    match.visit_count === 1 ? '1 previous visit' : `${match.visit_count} previous visits`;
  return (
    <Banner tone="info" title={`Returning patient — ${match.mr_no}`}>
      {match.last_visit.name}, {visits}. Details were filled in from the last visit, and this visit
      will be added to the same MR number.
    </Banner>
  );
}
